
import React, { useState, useEffect } from "react";
import classes from "./LoginPage.module.css";
import { motion } from "framer-motion";
import LinedSection from "../component/LinedSection";
import { useNavigate } from "react-router-dom";
import { loginApi } from "../http/http";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { setUser } from "../store/slices/userSlice";
import { useTranslation } from "react-i18next";

const LoginPage = () => {
  const [mobile, setMobile] = useState("");
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { user } = useSelector(
    (state) => state?.persisted?.userSlice || {}
  );

  const { t } = useTranslation();

  useEffect(() => {
    if (user?.token && user?.msisdn) {
      navigate("/home", { replace: true });
    }
  }, [user, navigate]);

  const handleFormSubmission = async (e) => {
    e.preventDefault();

    // Remove spaces, +, brackets, and other non-numeric characters.
   const digits = mobile.replace(/\D/g, "");

if (!digits) {
  toast.error(t("161"));
  return;
}

const msisdn = digits.startsWith("241")
  ? digits
  : `241${digits.startsWith("0") ? digits.slice(1) : digits}`;

    // Optional: validate the expected local number length here
    // if your backend requires a fixed length.

    try {
      setLoading(true);

      const response = await loginApi(msisdn);
      const data = response?.data;
      const result = data?.result;

      if (data?.success && result?.status === 1 && result?.token) {
        dispatch(setUser(result));

        toast.success(t("162"));
        navigate("/home", { replace: true });
        return;
      }

      if (result?.status === 0 || data?.status === 0) {
        toast.info(data?.message || result?.message || "Low Balance");
        return;
      }

      toast.error(
        data?.message || t("163")
      );
    
} catch (error) {
  const data = error?.response?.data;

  const isLowBalance =
    data?.status === 0 ||
    data?.result?.status === 0 ||
    data?.message?.toLowerCase().includes("low balance");

  if (isLowBalance) {
    navigate("/low-balance", { replace: true });
    return;
  }

  toast.error(
    data?.message || t("164")
  );
} finally {
  setLoading(false);
}

  };

  return (
    <main className={classes.main}>
      <div className={classes.glowLayer} />

      <LinedSection />

      <motion.section
        className={classes.container}
        initial={{ opacity: 0, y: 18 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, ease: "easeOut" }}
      >
        <div className={classes.bgGlowOne} />
        <div className={classes.bgGlowTwo} />

        <div className={classes.topLogoWrap}>
          <img
            src="/images/logo2.png"
            alt="MOOVGAMING"
            className={classes.logoImg}
          />
        </div>

        <div className={classes.headingWrap}>
          <h1 className={classes.title}>
            {t("34")}
            <span>{" "}{t("35")}</span>
          </h1>
        </div>

        <form className={classes.card} onSubmit={handleFormSubmission}>
          <div className={classes.formBlock}>
            <label className={classes.label} htmlFor="mobile">
              {t("38")}
            </label>

            <div className={classes.phoneField}>
              <input
                id="mobile"
                type="tel"
                inputMode="numeric"
                autoComplete="tel"
                placeholder={t("39")}
                value={mobile}
                onChange={(e) => setMobile(e.target.value)}
                className={classes.phoneInput}
                autoFocus
                required
                disabled={loading}
              />
            </div>
          </div>

          <button
            type="submit"
            className={classes.confirmBtn}
            disabled={loading}
          >
            {loading ? t("160") : t("46")}
          </button>
        </form>

        <div className={classes.footerText}>
          © UVCANN SOLUTIONS LLP
        </div>
      </motion.section>
    </main>
  );
};

export default LoginPage;
